<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; chatset=UTF-8" http-equiv="Content-Type"/>
<title>contents</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="chaptitle1"><img alt="" src="images/cont.jpg"/></p>
<p class="toc"><a href="#/frontmatter2"><img alt="" src="images/cont1.jpg"/> Word from Mallory</a></p>
<p class="toc"><a href="#/chapter1"><img alt="" src="images/cont2.jpg"/> A Contest</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample"><img alt="" src="images/cont3.jpg"/> Crunch Time</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample"><img alt="" src="images/cont4.jpg"/> The Envelope, Please</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample"><img alt="" src="images/cont5.jpg"/> Operation: Moms</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample"><img alt="" src="images/cont6.jpg"/> New York, New York</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample"><img alt="" src="images/cont7.jpg"/> The Unhappy List</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample"><img alt="" src="images/cont8.jpg"/> The Quiet Game</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample"><img alt="" src="images/cont9.jpg"/> The Girl Who Had It All, Almost</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample"><img alt="" src="images/cont10.jpg"/> An Idea</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample"><img alt="" src="images/cont11.jpg"/> Showtime</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample"><img alt="" src="images/cont12.jpg"/> Double Trouble</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample"><img alt="" src="images/cont13.jpg"/> Facing Fran</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample"><img alt="" src="images/cont14.jpg"/> On Top of the World</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample"><img alt="" src="images/cont15.jpg"/> Friends Forever</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample"><img alt="" src="images/cont16.jpg"/> SUPERSIZED Scrapbook</span></p>
<p class="toc"><span href="#/backmatter1" title="Link target outside of Sample"><img alt="" src="images/cont17.jpg"/> Pizza, Mallory and Mary Ann Style</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?03d02730